<!--
 * @Author: 陈梦男
 * @Date: 2024-05-22 14:44:21
 * @LastEditTime: 2024-06-14 09:29:21
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 国别报告数据管理
 * @FilePath: \web\src\views\ReportManager\CountryReportManager.vue
-->
<template>
  <section class="country-report-manager">
    <a-tabs v-model:activeKey="activeKey" class="country-report-manager-tabs">
      <a-tab-pane v-for="item in tabsList" :key="item.key" :tab="item.name" v-bind="item.option">
        <!-- <component :is="item.component"></component> -->
        <DataManager :type="'国别报告'" />
      </a-tab-pane>
    </a-tabs>
  </section>
</template>

<script setup>
import { onMounted, ref, reactive, getCurrentInstance, } from 'vue';
import config from '@/config/config';
import DataManager from '@/components/ReportComponents/DataManager/index.vue';
const activeKey = ref('1');

const tabsList = [
  {
    key: '1',
    name: '全球矿业研报库数据管理-国别报告',
    operation: [1, 2,],
    option: {
      forceRender: true,
    },
    component: DataManager,
  },
];

</script>

<style lang='scss'>
.country-report-manager {
  background-color: rgba(179, 150, 92, 0.05);
  height: 100%;

  /* tabs */
  .country-report-manager-tabs {
    height: 100%;

    /* 头 */
    .ant-tabs-top-bar {
      height: 0.5rem;
    }

    /* 内容区 */
    .ant-tabs-content {
      height: calc(100% - 0.5rem);

      .ant-tabs-tabpane {
        height: 100%;
      }
    }

    .ant-tabs {
      overflow: inherit;
    }

    .ant-tabs-nav-container {
      // background-color: rgba(10, 7, 0, 0.4);
    }

    .ant-tabs-ink-bar {
      background-color: transparent;
    }

    .ant-tabs-nav {
      .ant-tabs-tab:active {
        color: #fff;
        background-color: rgba(43, 34, 8, 0.7);
      }

      .ant-tabs-tab:hover {
        color: #fff;
        background-color: rgba(43, 34, 8, 0.7);
      }
    }

    .ant-tabs-bar {
      margin: 0;
      border-bottom: none;

      .ant-tabs-tab {
        color: rgba(255, 255, 255, 0.6);
        font-size: 0.16rem;
      }

      .ant-tabs-tab-active {
        color: #fff;
      }
    }
  }
}
</style>